import { AttachmentRotationAxisIds, AxisId } from "@animech/supermodel";
import { AttacherSolverContext } from "./attacher-solver-context";
import { AttributeBond, FamilyType } from "./attacher-attribute";

type RotationAxisValue = Extract<AttachmentRotationAxisIds, AxisId[]>;
type RotationAxisLookup = Exclude<AttachmentRotationAxisIds, RotationAxisValue>;

type CustomRotationAxisFilter =
	| RotationAxisValue
	| ((
			args: Parameters<RotationAxisLookup>[0] & {
				context: Readonly<AttacherSolverContext>;
			},
	  ) => ReturnType<RotationAxisLookup>);

const defaultRotationAxisFilter: CustomRotationAxisFilter = ["x", "y", "z"];

const rotationAxisFilterByFamilyBond: AttributeBond<
	FamilyType,
	CustomRotationAxisFilter
> = {} as const;

export function createAttachmentRotationAxisFilter(
	context: AttacherSolverContext,
): AttachmentRotationAxisIds {
	const { attacherAttributeMap } = context;

	return (args) => {
		const fromFamily = attacherAttributeMap.get("family", args.from);
		const toFamily = attacherAttributeMap.get("family", args.to);
		const lookupOrValue =
			rotationAxisFilterByFamilyBond[fromFamily]?.[toFamily] ??
			defaultRotationAxisFilter;

		return typeof lookupOrValue === "function"
			? lookupOrValue({ ...args, context })
			: lookupOrValue;
	};
}
